// Set up initial value for each cards
export default function initialCards() {
  return [
    {
      value: 'atmCards',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'knowTheOdds',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'setAbudget',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'expenseMoney',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'howLongYouWillPlay',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'balanceGambling',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'frequentBreaks',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'playForEntertainment',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },

    // Duplicate
    {
      value: 'atmCards',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'knowTheOdds',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'setAbudget',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'expenseMoney',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'howLongYouWillPlay',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'balanceGambling',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'frequentBreaks',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    },
    {
      value: 'playForEntertainment',
      matched: false,
      flipped: false,
      shake: false,
      fold: false,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/du/Game/GameData.js